import { Box, Typography, Container, Grid } from '@mui/material';
import servicesData from '../data/pricing.json';
import HeaderImage from '../components/HeaderImage';
import colors from '../theme/colors';

interface Service {
    name: string;
    duration: string | null;
    price: number | string;
}

interface Category {
    category: string;
    image: string;
    services: Service[];
}

const Pricing = () => {
    return (
        <Box>
            <HeaderImage />
            <Container sx={{ py: 6 }}>
                <Grid container spacing={4}>
                    {servicesData.map((category: Category, idx: number) => (
                        <Grid size={{ xs: 12, sm: 6 }} key={idx}>
                            <Box sx={{ mb: 8, textAlign: 'center' }}>
                                <Box
                                    component="img"
                                    src={category.image}
                                    alt={category.category}
                                    sx={{
                                        width: "90%",
                                        height: 200,
                                        borderRadius: 4, 
                                        objectFit: "cover",
                                        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)",
                                    }}
                                />
                                <Typography variant="h5" gutterBottom sx={{ py: 3 }}>
                                    {category.category}
                                </Typography>
                                <Box sx={{ mt: 2 }}>
                                    {category.services.map((service: Service, i: number) => (
                                        <Grid
                                            container
                                            key={i}
                                            justifyContent="space-between"
                                            alignItems="center"
                                            sx={{ mb: 1 }}
                                        >
                                            <Grid size={9}>
                                                <Typography variant="body1" textAlign="left">
                                                    {service.name}
                                                    {service.duration ? ` - ${service.duration}` : ''}
                                                </Typography>
                                            </Grid>
                                            <Grid
                                                size={3}
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'flex-end',
                                                }}
                                            >
                                                <Typography
                                                    variant="body1"
                                                    sx={{ fontWeight: 'bold', color: colors.lightPink, textAlign: 'right' }}
                                                >
                                                    {service.price} PLN
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    ))}

                                </Box>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default Pricing;
